@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
  ></app-datatable>
}
